import { i18n } from 'i18next'

export async function changeLanguage(i18n: i18n, locale: string) {
  await i18n.changeLanguage(locale)
}
